var map = {
	"./Google-SignIn.svg": "uoVZ",
	"./addconsignee.svg": "taZz",
	"./arrow-up.1.svg": "rUZp",
	"./arrow-up.svg": "ZQyL",
	"./checkboxtick.1.svg": "qUHt",
	"./checkboxtick.svg": "Fuss",
	"./column-picker.svg": "HZn7",
	"./containers.svg": "P3aj",
	"./dashboard_empty_state_icon.svg": "NCfC",
	"./destination.1.svg": "UTE3",
	"./destination.svg": "OwbQ",
	"./dot.1.svg": "LBwI",
	"./dot.svg": "FUq3",
	"./dropdown_arrow.svg": "bTxJ",
	"./fill_arrow.1.svg": "8O9m",
	"./fill_arrow.svg": "ZYnc",
	"./fill_arrow_white.1.svg": "mw+N",
	"./fill_arrow_white.svg": "IEWY",
	"./filtericon.svg": "Vtvp",
	"./generic_logo.svg": "Word",
	"./halt.svg": "wiok",
	"./hover-shape.1.svg": "R89M",
	"./hover-shape.svg": "epes",
	"./icon-column.1.svg": "M626",
	"./icon-column.svg": "3CmL",
	"./icon-no-lanes-bg.svg": "Y/ZP",
	"./icon-search.svg": "3iqG",
	"./icon-sort-arrow.svg": "kLZD",
	"./icon-sort.svg": "delb",
	"./invalid-material.svg": "s9U9",
	"./invoicetriangle.1.svg": "iuik",
	"./invoicetriangle.svg": "VCFU",
	"./loading_split.1.svg": "OfOq",
	"./loading_split.svg": "GCpw",
	"./logo.1.svg": "i61l",
	"./logo.svg": "KfkH",
	"./maricologo.svg": "HnSi",
	"./mdm.svg": "N29Y",
	"./menu.svg": "yhhc",
	"./minus.1.svg": "6Bjd",
	"./minus.svg": "I5h8",
	"./ms-symbollockup_signin_dark.svg": "i5Lq",
	"./noindents.1.svg": "dQ0D",
	"./noindents.svg": "OWh7",
	"./optima-settings.svg": "21JE",
	"./optima.svg": "9NYE",
	"./orders.svg": "pt1z",
	"./payment.svg": "wlSF",
	"./paymentemptystage.1.svg": "G4Vy",
	"./paymentemptystage.svg": "Afxt",
	"./plus.svg": "a5wV",
	"./setting.svg": "K9rE",
	"./source.svg": "7L+5",
	"./transporterlogo.svg": "Xw2G",
	"./truck-small.svg": "wGGT",
	"./truck.svg": "5tib",
	"./valid-invalid.svg": "iePq",
	"./valid-material.svg": "sYIU"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "M/XK";